export default [
  {
    type: 'text',
    content:
      'Eligibility: The cashback campaign is open to all individuals residing in KSA and UAE, aged 18 years or older,  The merchant list is limited and defined by Tamara. Only pay in full offered merchants are in the list of eligibility. Please check the Tamara app for pay in full merchant coverage.   ',
  },
  {
    type: 'text',
    content:
      'Campaign Period: The cashback campaign will run for a specified period as announced by Tamara. Tamara reserves the right to modify or terminate the campaign at its discretion without prior notice. ',
  },
  {
    type: 'text',
    content:
      'Qualifying Transactions: Participants in the campaign will qualify for the cashback offer when they make a payment using the Pay in Full payment option at participating merchants during the campaign period. ',
  },
  {
    type: 'text',
    content:
      "Cashback Offer: Tamara will offer a fixed percentage of cashback on qualifying transactions and this percentage will be subject to change depending on the merchant, subject to a maximum cap 150 SAR/AED per month per user as announced by Tamara. The cashback will be credited to the participant's account within a specified time after the qualifying transaction.",
  },
  {
    type: 'text',
    content:
      'Cashback Credit/Expiry/Returns: All cashback is only credited to the Tamara wallet. Cashback is credited within 7 business days. Orders that are canceled, returned, or partially refunded are not eligible for cashback rewards.',
  },

  {
    type: 'text',
    content:
      'Merchant Participation: Tamara will specify which merchants are participating in the campaign. Tamara reserves the right to add or remove participating merchants at any time during the campaign period.',
  },
  {
    type: 'text',
    content:
      'Campaign Communications: Tamara will communicate the campaign details and updates through various channels, including email, social media, and website announcements. Participants are responsible for checking these channels to stay informed about the campaign.',
  },
  {
    type: 'text',
    content:
      'Fraudulent Activity: Tamara reserves the right to disqualify any participant who engages in fraudulent activity or tampering with the campaign mechanics. Any attempt to manipulate or falsify information to participate in the campaign may result in legal action against the participant.',
  },
  {
    type: 'text',
    content:
      "Dispute Resolution: The parties agree that Tamara's  decision to resolve any disputes  arising out of the campaign will be binding and final, and the parties acknowledge that this won't affect the parties' right to escalate any dispute to the competent court when necessary.",
  },
  {
    type: 'text',
    content:
      "Limitation of Liability: Tamara will not be liable for any loss or damage incurred by participants in connection with the campaign. Tamara will not be responsible for any technical issues or failures related to the payment option or the participating merchant's system.",
  },
  {
    type: 'text',
    content:
      'Governing Law: The terms and conditions will be governed by the laws of the country where the campaign is being offered.',
  },
]
